import { useState } from 'react'
import { AssessmentModal } from './components/assessment-modal'
import { AssessmentPagination } from './components/assessment-pagination'
import { AssessmentProgress } from './components/assessment-progress'
import { AssessmentQuestion } from './components/assessment-question'
import { AssessmentSidebar } from './components/assessment-sidebar'

const sections = Array.from({ length: 10 }, (_, i) => ({
  id: `section-${i + 1}`,
  label: `Section ${i + 1}`,
  isCompleted: i === 0, // Only first section completed for demo
}))

const mockQuestions = Array.from({ length: 10 }, (_, i) => ({
  id: i + 1,
  text: 'Please provide accurate information regarding your employment history, educational background, and any relevant certifications. Have you verified all the details in this section?',
}))

export default function AssessmentPage() {
  const [activeSection, setActiveSection] = useState('section-1')
  const [currentPage, setCurrentPage] = useState(1)
  const [showProgress, setShowProgress] = useState(false)
  const [progress, setProgress] = useState(0)
  const [showModal, setShowModal] = useState(false)
  const [modalType, setModalType] = useState<
    'review' | 'great-work' | 'made-start'
  >('review')

  const handleSaveAndContinue = () => {
    // Simulate saving and moving to next page
    if (currentPage < 10) {
      setCurrentPage(currentPage + 1)
    } else {
      // Show completion modal
      setShowModal(true)
      setModalType('review')
    }
  }

  const handleSubmitAssessment = () => {
    setShowModal(false)
    setShowProgress(true)

    // Simulate progress
    let currentProgress = 0
    const interval = setInterval(() => {
      currentProgress += 10
      setProgress(currentProgress)

      if (currentProgress >= 100) {
        clearInterval(interval)
        setTimeout(() => {
          setShowProgress(false)
          setShowModal(true)
          setModalType('great-work')
        }, 500)
      }
    }, 300)
  }

  return (
    <div className='flex bg-white rounded-[10px] p-10'>
      {/* Sidebar */}
      <AssessmentSidebar
        sections={sections}
        activeSection={activeSection}
        sectionsCompleted={0}
        totalSections={4}
        progressPercentage={15}
        onSectionClick={setActiveSection}
      />

      {/* Main Content */}
      <div className='flex flex-1 flex-col'>
        <div className='flex-1 overflow-y-auto'>
          <div className='mx-auto max-w-4xl px-8 py-12'>
            {showProgress ? (
              <AssessmentProgress
                title='Analyzing Result...'
                progress={progress}
                isComplete={progress === 100}
              />
            ) : (
              <>
                {/* Section Header */}
                <div className='mb-8'>
                  <h1 className='mb-4 text-3xl font-bold text-gray-900'>
                    Section 1
                  </h1>
                  <p className='text-gray-600 leading-relaxed'>
                    This section contains important questions about your personal
                    information, employment history, and background details.
                    Please answer all questions accurately and completely. Your
                    responses will be used to conduct a thorough background
                    verification process. Ensure all information provided is
                    iaculis. Dui egestas cras integer id neque odio montes
                    fermentum in.
                  </p>
                </div>

                {/* Questions */}
                <div className='space-y-12'>
                  <AssessmentQuestion
                    questionNumber={currentPage}
                    questionText={mockQuestions[currentPage - 1]?.text || ''}
                  />

                  {currentPage === 2 && (
                    <AssessmentQuestion
                      questionNumber={currentPage + 1}
                      questionText={mockQuestions[currentPage]?.text || ''}
                    />
                  )}
                </div>
              </>
            )}
          </div>
        </div>

        {/* Pagination */}
        {!showProgress && (
          <AssessmentPagination
            currentPage={currentPage}
            totalPages={10}
            onPageChange={setCurrentPage}
            onPrevious={() => setCurrentPage(Math.max(1, currentPage - 1))}
            onSave={handleSaveAndContinue}
          />
        )}
      </div>

      {/* Modals */}
      <AssessmentModal
        open={showModal}
        onOpenChange={setShowModal}
        type={modalType}
        onPrimaryAction={() => {
          if (modalType === 'review') {
            handleSubmitAssessment()
          } else {
            setShowModal(false)
          }
        }}
        skippedQuestionsCount={modalType === 'review' ? 5 : 0}
      />
    </div>
  )
}
